export const rules = {
	// Card titles
	"rules.card.rules.title": "Rules",
	"rules.card.pointsAllocation.title": "Points Allocation",
	"rules.card.rulesContinued.title": "Rules (continued)",
	"rules.card.weeklyPrizes.title": "Weekly Prize Structure",

	// Main rules content
	"rules.intro":
		'All capitalized terms used in these rules (the <strong>"Rules"</strong>) shall carry the definition ascribed thereto in the terms and conditions (the <strong>"Terms and Conditions"</strong>).',

	"rules.temporary_notice":
		"Please note that prize winners over the period of 19th December 2025 - 2nd January 2026 will receive their prizes within the 7 (seven) days starting from 6th January 2026",

	"rules.rule1":
		"Participants can earn points by correctly predicting the score of each of five (5) games every week/round (as the case may be), relevant to the sports competition that the Betway Scores BW ScorePredict game relates to e.g. <em>English Premier League</em>, etc. The Betway Scores BW Score Predict competition will commence on 11 March 2025 and will conclude at the end of the 2025/2026 football season.",

	"rules.rule2.main": "Participants can earn additional bonus points by correctly predicting the following in each of the five (5) games:",
	"rules.rule2.a": "Correct final score",
	"rules.rule2.b": "Correct winner",
	"rules.rule2.c": "Correct home goals",
	"rules.rule2.d": "Correct away goals",
	"rules.rule2.e": "Correct goal difference",

	"rules.rule3": "Each week/round correlates with that sports competition's rounds.",

	"rules.rule4": "Points are allocated as follows for each of the following correct predictions by the Participant every week/round:",

	// Points allocation
	"rules.points.correctScore": "Correct final score",
	"rules.points.correctScoreValue": "50",
	"rules.points.correctWinner": "Correct winner",
	"rules.points.correctWinnerValue": "5",
	"rules.points.homeGoals": "Correct home goals",
	"rules.points.homeGoalsValue": "5",
	"rules.points.awayGoals": "Correct away goals",
	"rules.points.awayGoalsValue": "5",
	"rules.points.goalDifference": "Correct goal difference",
	"rules.points.goalDifferenceValue": "5",

	// Continued rules
	"rules.rule5":
		"Participants can make changes to their predictions at any point, up until 15 minutes before kickoff of each of the games of the relevant week/round.",

	"rules.rule6":
		"All signed in Betway Scores and/or BW Scores users are eligible to play Betway Scores BW ScorePredict, however only participants with a verified Betway account, at the point when prizes are to be awarded, are eligible to win prizes. Changes to the results of the game as per point 2. above which occur after awarding the prizes (e.g. annulment of result) will not be considered in retrospect.",

	"rules.rule7":
		"The qualifying and eligible Participant who finishes the season in first place and has a Betway Account will be the Grand Prize winner for the season will win a trip for two (2) to watch Arsenal play in London, including flights (if required), accommodation (if required) and £500 spending money.",

	"rules.rule8":
		"If the Grand Prize winner for the season is not able to travel due to not having a valid passport and/or Visa and/or any other limitations, they will receive a prize of €5,000 Cash balance, or the approximate equivalent in local currency at competition commencement date (being £4,500, R100,000 or GH₵ 60,000), into their Betway Account at the completion of the competition.",

	"rules.rule9":
		"The Grand Prize winner of the season can opt not to take up the experience and rather accept a prize of €5,000 Cash balance, or the approximate equivalent in local currency at competition commencement date (being £4,500, R100,000 or GH₵ 60,000), into their Betway Account.",

	"rules.rule10":
		'Weekly Prizes will be allocated to the "Top 10" performers every week/round who have a valid Betway Betting Account. If a Top 10 performer does not have a Betway Betting Account they will not be awarded a Weekly Prize.',

	"rules.rule11": "The weekly places 1 to 10 will win the following amounts of Cash balance, depending on their region, into their Betway Account.",

	"rules.rule12":
		"The Weekly Prizes will be awarded within 7 (seven) days of that week's results being finalised and the Grand Prize will be awarded within 7 (seven) days of the conclusion of the Betway Scores BW Score Predict competition.",

	"rules.rule13":
		"In the event of a tie for the Weekly Prizes the Cash balance for that position (and the relevant positions below it that are impacted by the tie) will be split equally between tied participants.",

	"rules.rule14":
		"In the event of a tie for the Grand Prize, a randomizer mechanism will be used to select only one of the tied participants as the winner of the Grand Prize.",

	// Weekly prize table data
	"rules.weeklyPrizes.position1.eur": "€150",
	"rules.weeklyPrizes.position1.gbp": "£150",
	"rules.weeklyPrizes.position1.zar": "R3000",
	"rules.weeklyPrizes.position1.ghs": "GH₵2000",

	"rules.weeklyPrizes.position2.eur": "€100",
	"rules.weeklyPrizes.position2.gbp": "£100",
	"rules.weeklyPrizes.position2.zar": "R2000",
	"rules.weeklyPrizes.position2.ghs": "GH₵1250",

	"rules.weeklyPrizes.position3.eur": "€75",
	"rules.weeklyPrizes.position3.gbp": "£75",
	"rules.weeklyPrizes.position3.zar": "R1500",
	"rules.weeklyPrizes.position3.ghs": "GH₵1000",

	"rules.weeklyPrizes.position4.eur": "€50",
	"rules.weeklyPrizes.position4.gbp": "£50",
	"rules.weeklyPrizes.position4.zar": "R1000",
	"rules.weeklyPrizes.position4.ghs": "GH₵600",

	"rules.weeklyPrizes.position5.eur": "€40",
	"rules.weeklyPrizes.position5.gbp": "£40",
	"rules.weeklyPrizes.position5.zar": "R800",
	"rules.weeklyPrizes.position5.ghs": "GH₵500",

	"rules.weeklyPrizes.position6.eur": "€30",
	"rules.weeklyPrizes.position6.gbp": "£30",
	"rules.weeklyPrizes.position6.zar": "R600",
	"rules.weeklyPrizes.position6.ghs": "GH₵400",

	"rules.weeklyPrizes.position7.eur": "€20",
	"rules.weeklyPrizes.position7.gbp": "£20",
	"rules.weeklyPrizes.position7.zar": "R400",
	"rules.weeklyPrizes.position7.ghs": "GH₵250",

	"rules.weeklyPrizes.position8.eur": "€15",
	"rules.weeklyPrizes.position8.gbp": "£15",
	"rules.weeklyPrizes.position8.zar": "R300",
	"rules.weeklyPrizes.position8.ghs": "GH₵200",

	"rules.weeklyPrizes.position9.eur": "€10",
	"rules.weeklyPrizes.position9.gbp": "£10",
	"rules.weeklyPrizes.position9.zar": "R200",
	"rules.weeklyPrizes.position9.ghs": "GH₵100",

	"rules.weeklyPrizes.position10.eur": "€10",
	"rules.weeklyPrizes.position10.gbp": "£10",
	"rules.weeklyPrizes.position10.zar": "R200",
	"rules.weeklyPrizes.position10.ghs": "GH₵100",

	// Table headers
	"rules.weeklyPrizes.header.position": "# Per Round",
	"rules.weeklyPrizes.header.eur": "EUR",
	"rules.weeklyPrizes.header.gbp": "GBP",
	"rules.weeklyPrizes.header.zar": "ZAR",
	"rules.weeklyPrizes.header.ghs": "GHS",
};
